import { DevTool } from 'little-state-machine-devtools';
import { Component } from 'react';
import { StateMachineProvider, createStore } from 'little-state-machine';
import Signposts from './Signposts/Signposts';
import DoneScreen from './DoneScreen';

import { MultipartFormProps, MultipartFormState} from '../../util/types';
import jumpToTop from '../../util/jumpToTop';

createStore({
  formData: {},
  students: [],
});

// Build steps object for use with the footer
function getStepsObject(steps: any[], currentStep: number) {
  return steps.reduce((accum, step, index) => {
    let status = 'inactive';
    if (currentStep > index) status = 'completed';
    else if (currentStep === index) status = 'active';
    accum.push({
      // name: step.name,
      label: step.props.label,
      mobileLabel: step.props.mobileLabel,
      status: status,
    });
    return accum;
  },[]);
}

/**
 * A MultipartForm component
 * @param props
 */
class MultipartForm extends Component<MultipartFormProps, MultipartFormState> {
  state: MultipartFormState = {
    stepIndex: 0,
    done: false,
  }

  goToNextStep = () => {
    // Don't go past end
    if (this.state.stepIndex < this.props.stepComponents.length - 1) {
      this.setState({
        stepIndex: this.state.stepIndex + 1,
      }, () => jumpToTop());
    } else {
      console.log('at end already');
    }
  }

  goToPreviousStep = () => {
    // Don't go past beginning
    if (this.state.stepIndex > 0) {
      this.setState({
        stepIndex: this.state.stepIndex - 1,
      }, () => jumpToTop());
    } else {
      console.log('at beginning already');
    }
  }

  goToStep = (stepIndex: number, fieldName?: string) => {
    // If valid index
    if (stepIndex >= 0 && stepIndex <= this.props.stepComponents.length - 1) {
      this.setState({
        stepIndex,
      }, () => {
        jumpToTop();
        if (fieldName) {
          const targetField = document.querySelector(`[name="${fieldName}"]`);
          if (targetField && targetField instanceof HTMLElement) targetField.focus();
        }
      });
    } else {
      console.log(`stepIndex ${stepIndex} is not valid`);
    }
  }

  setDone = (done: boolean) => {
    this.setState({
      // done: false,
      done,
    }, () => jumpToTop());
  }

  render() {
    // console.log(this.state);

    const stepComponent = this.props.stepComponents[this.state.stepIndex] || <p>Could not find step</p>;
    // Create instance of the step and add props

    const stepInstance = <stepComponent.type
      {...stepComponent.props}
      next={this.goToNextStep}
      prev={this.goToPreviousStep}
      goToStep={this.goToStep}
      setDone={this.setDone}
    />;

    const stepsObject = getStepsObject(this.props.stepComponents, this.state.stepIndex);

    return (
      <StateMachineProvider>
      {
        this.state.done ?
        <DoneScreen content={this.props.doneScreenContent} />
        : <>
          {stepInstance}
          <Signposts
            stepsObject={ stepsObject }
          />
        </>
      }
      <DevTool />
    </StateMachineProvider>
    );
  }
};

export default MultipartForm;
